import React, { useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom'; 
import { Typography, Paper, Button, FormControlLabel, Checkbox, IconButton } from '@mui/material'
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import InfoIcon from '@mui/icons-material/Info';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import NavigationButtons from '../container/NavigationButtons';

import logo from '../images/green_check.png';
import ReactTooltip from "react-tooltip";

const StyledReactTooltip = styled(ReactTooltip)({
  width: 300,
  maxWidth: '40%',
});

function Start(props) {
// class Start extends Component {
  // const [activeStep, setActiveStep] = useState(props.activeStep);
  const navigate = useNavigate(); 
  const [start, setStart] = useState(props.start);
  const [exempt1, setExempt1] = useState(false);
  const [exempt2, setExempt2] = useState(false);
  const [exempt3, setExempt3] = useState(false);
  const [exempt4, setExempt4] = useState(false);

  useEffect(() => {
    setStart(props.start)
 }, [props.start])

  // constructor(props) {
  //   super(props);
  //   this.state = {start: props.start, activeStep: props.activeStep,
  //     exempt1: false, exempt2: false, exempt3: false, exempt4: false};
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //     if(nextProps.start !== prevState.start) { 
  //       // console.log(JSON.stringify(nextProps.start) + ' ' + JSON.stringify(prevState.start))         
  //       return { start: nextProps.start }
  //       // if(prevState.start.personalOrBusiness !== '' && prevState.start.myselfOrSomeone !== '' 
  //       //     && prevState.start.mailingOrPhysical !== '') {
  //       //   return { start: nextProps.start }
  //       // }
  //     }
  // }

  const selectPCT = (selection) => {
    const newStart = {
      ...start,
      pct: selection,
      mailingOrPhysical: selection === 'Y'? 'M' : start.mailingOrPhysical,
      myselfOrSomeone: selection === 'Y'? 'S' : start.myselfOrSomeone
    };

    setStart(newStart)
    props.updateStart(newStart);
  }

  const selectMailingOrPhysical = (selection) => {
    const newStart = {
      ...start,
      mailingOrPhysical: selection
    };

    setStart(newStart)
    props.updateStart(newStart);
  }

  const selectPersonalOrBusiness = (selection) => {
    const newStart = {
      ...start,
      personalOrBusiness: selection
    };

    setStart(newStart)
    props.updateStart(newStart);
  }

  const selectMyselfOrSomeone = (selection) => {
    const newStart = {
      ...start,
      myselfOrSomeone: selection
    };

    setStart(newStart)
    props.updateStart(newStart);
  }

  const handleExemptionChecked = (propertyName) => (event) => {
    if (propertyName === 'exempt1') {
      setExempt1(exempt1? false : true)
      // this.setState({ exempt1: exempt1? false : true });
    } else
    if (propertyName === 'exempt2') {
      setExempt2(exempt2? false : true)
    } else
    if (propertyName === 'exempt3') {
      setExempt3(exempt3? false : true)
    } else
    if (propertyName === 'exempt4') {
      setExempt4(exempt4? false : true)
    }
  }

  const startOver = () => {    
    navigate('/');
  }

  return (
          <Paper sx={{
            padding: 2,
            textAlign: 'left',
            color: 'text.primary',
            backgroundColor: '#ffffff',
            borderRadius: '12px'
          }}>

            {start.pct === '' &&              
            <Grid>
            <Typography role="heading" sx={{
              fontSize: { xs: '0.9375rem', sm: '1.1875rem' },
              fontWeight: "bold",
              mb: '2px',
              color: '#000000',
            }} align='center'>Are you a Professional Currency Transporter/Armored Car Company?
            <span data-tip="" data-for='currTrans'>                  
                <IconButton sx={{
                  verticalAlign: 'text-top',
                  color: '#3939c8',
                  pt: '0px',
                  pb: '12px',
                }} aria-label="A Professional Currency Transporter is any one engaged as a business in the transportation of currency, other monetary instruments, or commercial papers.">
                  <InfoIcon />
                </IconButton> </span>
                <StyledReactTooltip id='currTrans'>
                  {"A Professional Currency Transporter is any one engaged as a business in the transportation of currency, other monetary instruments, or commercial papers."}
                </StyledReactTooltip>
            </Typography>              
            <Grid container sx={{justifyContent: "center"}}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Y1')} >
                Yes
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('N')} >
                No
              </Button>
            </Grid>
            </Grid>
            }

            {start.pct === 'Y1' && start.personalOrBusiness === '' &&
            <Grid>
            <Typography role="heading" sx={{
              fontSize: { xs: '0.9375rem', sm: '1.1875rem' },
              fontWeight: "bold",
              mb: '2px',
              color: '#000000',
            }} align='center'>Check if exempted from filing?
            <span data-tip="" data-for='currTrans1'>                  
                <IconButton sx={{
                  verticalAlign: 'text-top',
                  color: '#3939c8',
                  pt: '0px',
                  pb: '12px',
                }} aria-label="Check Exemption to see if you can exempt yourself from filing FinCEN CMIR -- 31 CFR §1010.340 (c)(9).  
                                          If you are aware of the exemption conditions and know that you can be exempted, you can skip this check.">
                  <InfoIcon />
                </IconButton> </span>
                <StyledReactTooltip id='currTrans1'>
                  {"Check Exemption to see if you can exempt yourself from filing FinCEN CMIR -- 31 CFR §1010.340 (c)(9).  "  +
                  "If you are aware of the exemption conditions " + 
                  "and know that you can be exempted, you can skip this check."}
                </StyledReactTooltip>
            </Typography>              
            <Grid container sx={{justifyContent: "center"}}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Y2')} >
                Check Exemption
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPCT('Y')} >
                Skip Check
              </Button>
            </Grid>
            </Grid>
            }

            {start.pct === 'Y2' && start.personalOrBusiness === '' &&
            <Grid>
              <Typography role="heading" sx={{
                fontSize: '1.1875rem',
                fontWeight: "bold",
                color: '#000000'
              }} align='center' gutterBottom>Exemption Check</Typography>
              <Typography sx={{
                fontSize: '1.0625rem',
                fontStyle: 'italic',
                color: '#000000'
              }} align='center' gutterBottom>**All of the below should be met</Typography>
              <Typography sx={{
                fontSize: '1.0625rem',
                fontStyle: 'italic',
                mb: '28px',
                color: '#000000'
              }} align='center' gutterBottom>**Other exemptions are not applicable when ‘common carriers of currencies’ is involved in the transportation
              <span data-tip="" data-for='currTrans2'>                  
                <IconButton sx={{
                  verticalAlign: 'text-top',
                  color: '#3939c8',
                  pt: '0px',
                  pb: '12px',
                }} aria-label="Although the CMIR regulations include a number of exemptions that apply to other parties, a common carrier 
                  of currency may not claim for itself any exemption for filing a CMIR that might be applicable to other parties. For example, banks, 
                  foreign banks or brokers or dealers in securities are themselves exempted from filing a CMIR with respect to currency or other monetary 
                  instruments that they mail or ship via the postal service or a common carrier. A common carrier of currency cannot apply this exemption to 
                  itself (although, as described above, the limited exemption may apply). For example, if a common carrier of currency picks up at an airport a 
                  cargo of currency air-shipped to a U.S. bank from abroad, the common carrier has an obligation to file a CMIR even though the 
                  bank does not. -- 31 CFR §1010.340 (c).">
                  <InfoIcon />
                </IconButton> </span>
                <StyledReactTooltip id='currTrans2'>
                  {"Although the CMIR regulations include a number of exemptions that apply to other parties, a common carrier of currency may not claim for itself any exemption for filing a CMIR that might be applicable to other parties. For example, banks, foreign banks or brokers or dealers in securities are themselves exempted from filing a CMIR with respect to currency or other monetary instruments that they mail or ship via the postal service or a common carrier. A common carrier of currency cannot apply this exemption to itself (although, as described above, the limited exemption may apply). For example, if a common carrier of currency picks up at an airport a cargo of currency air-shipped to a U.S. bank from abroad, the common carrier has an obligation to file a CMIR even though the bank does not. -- 31 CFR §1010.340 (c)."}
                </StyledReactTooltip>
              </Typography>

              <Grid container sx={{ alignItems: "center", justifyContent: "flex-start" }}>
                <FormControlLabel
                  label="The transportation consists of currency or other monetary instruments 
                  imported into the United States or exported out of the United States"
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                    checkedIcon={<CheckBoxIcon fontSize="large" />}
                    checked={exempt1}
                    onChange={handleExemptionChecked('exempt1')}
                    value={exempt1}
                  />
                  }
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                    }
                  }}
                />
              </Grid>
              <Grid container sx={{alignItems: "center", justifyContent: "flex-start"}}>
                <FormControlLabel
                  label="The transportation takes place overland"
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                    checkedIcon={<CheckBoxIcon fontSize="large" />}
                    checked={exempt2}
                    onChange={handleExemptionChecked('exempt2')}
                    value={exempt2}
                  />
                  }
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                    }
                  }}
                />
              </Grid>
              <Grid container sx={{alignItems: "center", justifyContent: "flex-start"}}>
                <FormControlLabel
                  label="The transportation takes place between a bank or a broker or dealer in 
                  securities, on the U.S. side, and a non-U.S. person, on the foreign side"
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                    checkedIcon={<CheckBoxIcon fontSize="large" />}
                    checked={exempt3}
                    onChange={handleExemptionChecked('exempt3')}
                    value={exempt3}
                  />
                  }
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                    }
                  }}
                />
              </Grid>
              <Grid container sx={{alignItems: "center", justifyContent: "flex-start"}}>
                <FormControlLabel
                  label="The shipment is picked up or delivered at the established office of the 
                  bank or a broker or dealer in securities on the U.S"
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                    checkedIcon={<CheckBoxIcon fontSize="large" />}
                    checked={exempt4}
                    onChange={handleExemptionChecked('exempt4')}
                    value={exempt4}
                  />
                  }
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto',
                      fontWeight: '600',
                      fontSize: '1.125rem',
                    }
                  }}
                />
              </Grid>

              <Grid container sx={{justifyContent: "center"}}>  
                <Button sx={{
                  fontSize: { xs: '0.875rem', sm: '1.125rem' },
                  fontWeight: "620",
                  backgroundColor: "#324bb5",
                  '&:hover': {
                    backgroundColor: '#1976d2',
                  },
                  margin: { xs: '12px', sm: '22px' },
                }} disabled={exempt1 && exempt2 && exempt3 && exempt4}
                variant="contained" color="primary" onClick={() => selectPCT('Y')} >
                  Proceed
                </Button>
                <Button sx={{
                  fontSize: { xs: '0.875rem', sm: '1.125rem' },
                  fontWeight: "620",
                  backgroundColor: "#324bb5",
                  '&:hover': {
                    backgroundColor: '#1976d2',
                  },
                  margin: { xs: '12px', sm: '22px' },
                }} disabled={!exempt1 || !exempt2 || !exempt3 || !exempt4}
                  variant="contained" size="medium" color="primary" onClick={() => selectPCT('Y3')} >
                  Exempted
                </Button>                  
              </Grid>
            </Grid>
            }

            {start.pct === 'Y3' &&
            <Grid>
            <Typography role="heading" sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '28px',
              color: '#000000'
            }} align='center' gutterBottom>You are Exempted from Filing</Typography>
            <Grid container sx={{justifyContent: "center"}}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" color="primary" onClick={() => startOver()} >
                Exit to Home
              </Button>
              {/* <Button className={classes.button} variant="contained" size="medium" color="primary" onClick={() => this.selectPCT('Y')} >
                Still Proceed to File
              </Button> */}
            </Grid>
            </Grid>
            }

            {(start.pct === 'N' || start.pct === 'Y') && start.personalOrBusiness === '' &&             
            <Grid>
            <Typography role="heading" sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '28px',
              color: '#000000'
            }} align='center' gutterBottom>Are you transporting currency or monetary instruments for personal or business purposes?</Typography>
            <Grid container sx={{justifyContent: "center"}}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" color="primary" onClick={() => selectPersonalOrBusiness('P')} >
                Personal
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectPersonalOrBusiness('B')} >
                Business
              </Button>
            </Grid>
            </Grid>
            }

            {start.personalOrBusiness !== '' && start.mailingOrPhysical === '' &&              
            <Grid>
            <Typography role="heading" sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '28px',
              color: '#000000'
            }} align='center' gutterBottom>How are you transporting the currency or monetary instruments?</Typography>
            <Grid container sx={{justifyContent: "center"}}>               
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectMailingOrPhysical('P')} >
                Physically Transporting
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" color="primary" onClick={() => selectMailingOrPhysical('M')} >
                Mailing / Shipping
              </Button>
            </Grid>
            </Grid>
            }

            {start.personalOrBusiness !== '' && start.mailingOrPhysical !== '' && start.myselfOrSomeone === '' &&
            <Grid>
            <Typography role="heading" sx={{
              fontSize: '1.1875rem',
              fontWeight: "bold",
              mb: '28px',
              color: '#000000'
            }} align='center' gutterBottom>Does the currency or monetary instruments belong to the traveler or someone else?</Typography>
            <Grid container sx={{justifyContent: "center"}}>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectMyselfOrSomeone('M')} >
                Traveler 
              </Button>
              <Button sx={{
                fontSize: { xs: '0.875rem', sm: '1.125rem' },
                fontWeight: "620",
                backgroundColor: "#324bb5",
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
                margin: { xs: '12px', sm: '22px' },
              }} variant="contained" size="medium" color="primary" onClick={() => selectMyselfOrSomeone('S')} >
                Someone Else
              </Button>
            </Grid>
            </Grid>
            }
            
            {start.mailingOrPhysical !== '' && start.personalOrBusiness !== '' && start.myselfOrSomeone !== '' &&
            // <Grow in={true} {...{ timeout: 2000 } }>
            <Grid>
              <Typography role="heading" sx={{
                fontSize: '1.1875rem',
                fontWeight: "bold",
                mb: '28px',
                color: '#000000'
              }} align='center' gutterBottom>Review your selections. Press Next to Continue.</Typography>
              {start.pct === 'Y' &&
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: "500",
                color: '#000000',
                ml: { xs: '14px', sm: '60px' },
                justifyContent: 'center', 
                alignItems: 'left'
              }}  gutterBottom>
                  <img src={logo} alt="Logo" height="15px" width="20px" style={{marginRight: 0.5 +'em'}}/>
                  Professional Currency Transporter/Armored Car Company
              </Typography>
              }
              {start.pct === 'Y' &&
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: "500",
                color: '#000000',
                ml: { xs: '14px', sm: '60px' },
                justifyContent: 'center', 
                alignItems: 'left'
              }} gutterBottom>
                  <img src={logo} alt="Logo" height="15px" width="20px" style={{marginRight: 0.5 +'em'}}/>
                  {start.personalOrBusiness === 'P'? 'Personal Currency Carrier' : 'Business Currency Carrier'}
              </Typography>
              }
              {start.pct === 'N' &&
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: "500",
                color: '#000000',
                ml: { xs: '14px', sm: '60px' },
                justifyContent: 'center', 
                alignItems: 'left'
              }} gutterBottom>
                  <img src={logo} alt="Logo" height="15px" width="20px" style={{marginRight: 0.5 +'em'}}/>
                  {start.personalOrBusiness === 'P'? 'Personal Travel' : 'Business Travel'}
              </Typography>
              }
              {start.pct === 'N' &&
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: "500",
                color: '#000000',
                ml: { xs: '14px', sm: '60px' },
                justifyContent: 'center', 
                alignItems: 'left'
              }} gutterBottom>
                <img src={logo} alt="Logo" height="15px" width="20px" style={{marginRight: 0.5 +'em'}}/>
                {start.mailingOrPhysical === 'M'? 'Mailing / Shipping' : 'Physically Transporting'}
              </Typography>
              }
                {start.pct === 'N' &&
              <Typography sx={{
                fontSize: '1.125rem',
                fontWeight: "500",
                color: '#000000',
                ml: { xs: '14px', sm: '60px' },
                justifyContent: 'center', 
                alignItems: 'left'
              }} gutterBottom>
                <img src={logo} alt="Logo" height="15px" width="20px" style={{marginRight: 0.5 +'em'}}/>
                {start.myselfOrSomeone === 'M'? 'Currency or Monetary Instrument belongs to Traveler' : 'Currency or Monetary Instrument belongs to Someone Else'}
              </Typography>
              }
              <NavigationButtons start={start} formCompleted={props.formCompleted} />
            </Grid>
            // </Grow>
            }
        </Paper>  
  );
}

export default Start;